export const ignoreCatch = promise =>
  promise.catch(err => {
    // eslint-disable-next-line no-console
    console.warn(err.message);
    // don't propagate error to continue process
  });
